module.exports = __webpack_public_path__ + "501e95b71a0958576d6e684815755d52.pdf";